import http from '../httpService';
import {getLanguage, t} from 'react-switch-lang';

export function getAllProcesses() {
  return http.get(`/processes?size=1000`);
}
export function updateProcess(payload) {
  return http.put('/processes', payload);
}

export function createProcess(payload) {
  return http.post('/processes', payload);
}

export function deleteProcess(id) {
  return http.delete(`/processes/${id}`);
}